import React, { useContext, useState } from 'react';
import { LanguageContext } from '../App';
import { useAuth } from '../contexts/AuthContext';
import './Login.css';

const InitialPasswordChange = () => {
  const { language } = useContext(LanguageContext);
  const { currentUser, changeInitialPassword, logout } = useAuth();
  const [password, setPassword] = useState('');
  const [confirmation, setConfirmation] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [error, setError] = useState('');
  const [saving, setSaving] = useState(false);

  const copy = language === 'es' ? {
    title: 'Crea tu contraseña',
    subtitle: 'Este paso protege tu acceso antes de mostrar los reclamos.',
    password: 'Nueva contraseña',
    confirmation: 'Confirmar contraseña',
    action: 'Guardar y entrar',
    saving: 'Protegiendo tu cuenta…',
    mismatch: 'Las contraseñas no coinciden.',
    short: 'Usa al menos 8 caracteres.',
    show: 'Mostrar contraseña',
    hide: 'Ocultar contraseña',
    logout: 'Cerrar sesión'
  } : {
    title: 'Create your password',
    subtitle: 'This step protects your access before showing your claims.',
    password: 'New password',
    confirmation: 'Confirm password',
    action: 'Save and continue',
    saving: 'Securing your account…',
    mismatch: 'Passwords do not match.',
    short: 'Use at least 8 characters.',
    show: 'Show password',
    hide: 'Hide password',
    logout: 'Sign out'
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    setError('');
    if (password.length < 8) return setError(copy.short);
    if (password !== confirmation) return setError(copy.mismatch);
    setSaving(true);
    const result = await changeInitialPassword(password);
    if (!result.success) setError(result.error);
    setSaving(false);
  };

  return (
    <main className="auth-login-container ipc-container">
      <section className="auth-login-card ipc-card" aria-labelledby="ipc-title">
        <div className="ipc-lock"><i className="fa-solid fa-shield-halved"></i></div>
        <div className="auth-login-header">
          <h2 id="ipc-title">{copy.title}</h2>
          <p>{copy.subtitle}</p>
          <span className="ipc-email">{currentUser?.email}</span>
        </div>
        <form onSubmit={handleSubmit} className="auth-login-form">
          <div className="auth-form-group">
            <div className="auth-input-wrapper">
              <i className="fa-solid fa-lock auth-input-icon-left"></i>
              <input id="ipc-password" type={showPassword ? 'text' : 'password'} value={password} onChange={(e) => setPassword(e.target.value)} placeholder=" " minLength="8" autoComplete="new-password" required
                aria-invalid={error ? 'true' : undefined} aria-describedby={error ? 'ipc-error' : undefined} />
              <label htmlFor="ipc-password">{copy.password}</label>
              <button type="button" className="auth-password-toggle" onClick={() => setShowPassword(value => !value)} aria-label={showPassword ? copy.hide : copy.show}>
                <i className={`fa-solid ${showPassword ? 'fa-eye-slash' : 'fa-eye'}`} aria-hidden="true"></i>
              </button>
            </div>
          </div>
          <div className="auth-form-group">
            <div className="auth-input-wrapper">
              <i className="fa-solid fa-lock auth-input-icon-left"></i>
              <input id="ipc-confirmation" type={showPassword ? 'text' : 'password'} value={confirmation} onChange={(e) => setConfirmation(e.target.value)} placeholder=" " minLength="8" autoComplete="new-password" required
                aria-invalid={error ? 'true' : undefined} aria-describedby={error ? 'ipc-error' : undefined} />
              <label htmlFor="ipc-confirmation">{copy.confirmation}</label>
            </div>
          </div>
          {error && <div className="auth-error-message" id="ipc-error" role="alert"><i className="fa-solid fa-circle-exclamation" aria-hidden="true"></i><span>{error}</span></div>}
          <button className="auth-btn-login" type="submit" disabled={saving}>
            {saving ? <><i className="fa-solid fa-spinner fa-spin"></i><span>{copy.saving}</span></> : <><span>{copy.action}</span><i className="fa-solid fa-arrow-right"></i></>}
          </button>
          <button className="ipc-logout" type="button" onClick={logout}>{copy.logout}</button>
        </form>
      </section>
    </main>
  );
};

export default InitialPasswordChange;
